import "./style.scss";
import { Button } from "antd";
import homeJson from "./home.json";
import { iconsAndImages } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { openWhatsApp } from "../../utils";
import { FaArrowRight } from "react-icons/fa6";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export const Home = () => {
    const navigate = useNavigate();
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true
        });
    }, []);

    return (
        <>
            <section className="home-bg d-flex align-items-center position-relative">
                {/* <video
                    className="bg-video"
                    autoPlay
                    loop
                    muted
                    playsInline
                >
                    <source src={homeVideo} type="video/mp4" />
                </video> */}

                <div className="container position-relative content-layer">
                    <div className="row align-items-center gy-4">

                        <div className="col-12 col-lg-7 text-center text-lg-start">
                            <h1
                                className="text-light home-title bebas-neue-regular pt-5 pt-md-0"
                                dangerouslySetInnerHTML={{ __html: homeJson?.mainCont }}
                            />

                            <p
                                className="text-light home-desc py-4"
                                dangerouslySetInnerHTML={{ __html: homeJson?.subCont }}
                            />

                            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                                <Button type="primary" size="large" onClick={() => navigate("/contact")}>
                                    {homeJson?.btnCont1}
                                </Button>

                                <a
                                    href="/products"
                                    className="border text-center d-flex align-items-center gap-3 py-2 justify-content-center text-decoration-none text-light px-4 rounded view-btn"
                                >
                                    {homeJson?.btnCont2}
                                    <FaArrowRight />
                                </a>
                            </div>
                        </div>

                        <div className="col-12 col-lg-5 d-flex justify-content-center">
                            <div className="blur-home-right rainbow-glass w-100">

                                <div className="d-flex align-items-center gap-3 py-3">
                                    <img loading="lazy" src={iconsAndImages[homeJson?.messageHomeIcon]} alt="" />
                                    <h5>{homeJson?.messageMainCont}</h5>
                                </div>

                                <p className="text-light">
                                    {homeJson?.messageSubCont}
                                </p>

                                <Button
                                    className="w-100 fw-bold py-4"
                                    onClick={() => openWhatsApp()}
                                >
                                    <img loading="lazy" src={iconsAndImages[homeJson?.messageRightIcon]} alt="" />
                                    {homeJson?.messageBtnConent}
                                </Button>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="home-below-section py-5">
                <div className="container py-3">
                    <div className="row g-4 justify-content-center">
                        {homeJson?.transportDetails?.map((details, index) => {
                            const animations = ["fade-right", "fade-down", "fade-left", "fade-up"];
                            const anim = animations[index % animations.length];
                            return (<div className="col-12 col-sm-6 col-lg-4" data-aos={anim} key={index}>
                                <div className="transport-card h-100">
                                    <img
                                        src={iconsAndImages[details?.icon]}
                                        alt=""
                                        loading="lazy"
                                        className="transport-icon"
                                    />
                                    <h4 className="py-3">{details?.mainContent}</h4>
                                    <p className="mb-0" style={{ color: "#475569" }}>{details?.subContent}</p>
                                </div>
                            </div>
                            )
                        })}
                    </div>
                </div>
            </section>
        </>
    );
};
